var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fields fields_1608103850620"},[_c('div',{staticClass:"box",class:{ padding: _vm.paddingBottom }},[_vm._t("default")],2),_c('button',{staticClass:"btn-confirm",on:{"click":_vm.onClick}},[_vm._v("确认")])])}
var staticRenderFns = []

export { render, staticRenderFns }